<div class="container-fluid">
  <div>
    <div class="row">
      <div id="no-fixed-height" class="col-xl-12 col-lg-12 margin-top-16">
        <p-card>
          <div>
            <div class="sub-header">{{ 'bikeshop.quicklaunch.overview' | translate }}</div>
            <div class="metric-container">
              <div [ngStyle]="{order: activeTechnicians>0 ? 0 : 1}">
                <app-overview-widget 
                  [busy]="techniciansBusy"
                  [metric]="activeTechnicians"
                  [total]="technicians.length===0 ? 1 : technicians.length"
                  metricName="{{'bikeshop.quicklaunch.active_technicians' | translate}}" 
                  [color]="chartColor1"
                  [type]="overviewActionTypes.USERS"
                  videoTooltip="{{ 'bikeshop.quicklaunch.tooltip.active_technicians' | translate}}"
                  actionText="{{ 'bikeshop.quicklaunch.goto_user_admin' | translate}}" (video)="tutorialAction($event)"
                  (action)="overviewAction($event)">
                </app-overview-widget>
              </div>
              <div [ngStyle]="{order: activeServiceTypes>0 ? 0 : 1}">
                <app-overview-widget 
                  [busy]="busyServiceTypes"
                  [metric]="activeServiceTypes"
                  [total]="serviceTypes.length ===0 ? 1 : serviceTypes.length"
                  metricName="{{'bikeshop.quicklaunch.active_servicetypes' | translate}}"
                  [color]="chartColor2"
                  [type]="overviewActionTypes.SERVICE_TYPES"
                  videoTooltip="{{ 'bikeshop.quicklaunch.tooltip.active_servicetypes' | translate}}"
                  actionText="{{ 'bikeshop.quicklaunch.goto_service_types' | translate}}"
                  (video)="tutorialAction($event)" (action)="overviewAction($event)">
                </app-overview-widget>
              </div>
              <div [ngStyle]="{order: activeMessageTemplates>0 ? 0 : 1}">
                <app-overview-widget 
                  [busy]="busyMessages"
                  [metric]="activeMessageTemplates"
                  [total]="messageTemplates.length === 0 ? 1 : messageTemplates.length"
                  metricName="{{'bikeshop.quicklaunch.active_messagetemplates' | translate}}"
                  [color]="chartColor3"
                  [type]="overviewActionTypes.MESSAGE_TEMPLATES"
                  videoTooltip="{{ 'bikeshop.quicklaunch.tooltip.active_messagetemplates' | translate}}"
                  actionText="{{ 'bikeshop.quicklaunch.goto_message_templates' | translate}}"
                  (video)="tutorialAction($event)" (action)="overviewAction($event)">
                </app-overview-widget>
              </div>
              <div [ngStyle]="{order: cyclists.length>0 ? 0 : 1}">
                <app-overview-widget 
                  [busy]="busyCyclists"
                  [metric]="cyclists.length" 
                  [total]="cyclists.length===0 ? 1 : cyclists.length"
                  metricName="{{'bikeshop.quicklaunch.customers' | translate}}" 
                  [color]="chartColor4"
                  [type]="overviewActionTypes.CUSTOMERS"
                  videoTooltip="{{ 'bikeshop.quicklaunch.tooltip.customers' | translate}}"
                  actionText="{{ 'bikeshop.quicklaunch.goto_customers' | translate}}" (video)="tutorialAction($event)"
                  (action)="overviewAction($event)">
                  ></app-overview-widget>
              </div>
              <div [ngStyle]="{order: posProducts > 0 ? 0 : 1}">
                <app-overview-widget 
                  [busy]="busyPosProducts"
                  [metric]="posProducts === -1 ? 0 : posProducts"
                  [total]="posProducts === -1 ? 0 : posProducts"
                  metricName="{{'bikeshop.quicklaunch.pos_product_count' | translate}}"
                  [color]="chartColor5"
                  [type]="overviewActionTypes.POS_CONFIG"
                  videoTooltip="{{ 'bikeshop.quicklaunch.tooltip.pos_config' | translate}}"
                  actionText="{{ 'bikeshop.quicklaunch.goto_pos_configuration' | translate}}"
                  (video)="tutorialAction($event)" (action)="overviewAction($event)">
                </app-overview-widget>
              </div>
            </div>

          </div>
        </p-card>
      </div>
    </div>
    <div class="header-container">
        <div class="page-header"><span class="fa fa-gears"></span>{{ 'bikeshop.menu.quicklaunch' | translate }}</div>
    </div>
    <div class="row">
      <div class="col-xl-4 col-lg-6 margin-bottom-32">
        <p-card>
          <div>
            <div class="card-1"></div>
            <div class="sub-header">{{ 'bikeshop.quicklaunch.things_to_do' | translate }}</div>
            <div class="configuration">
              <div>{{ 'bikeshop.quicklaunch.pos_configured' | translate }}<span class="fa right"
                  [ngClass]="{'fail fa-exclamation-triangle' : posConfigured===0, 'configured hubtiger-check' : posConfigured===1}"></span>
              </div>
              <div>{{ 'bikeshop.quicklaunch.pos_products_sync' | translate }}<span class="fa right"
                  [ngClass]="{'fail fa-exclamation-triangle' : posProducts===0, 'configured hubtiger-check' : posProducts>0}"></span>
              </div>
              <!--<div>{{ 'bikeshop.quicklaunch.jobcardCompleted' | translate }}<span class="fa right"
                  [ngClass]="{'fail' : jobCardConfigured===0, 'configured hubtiger-check' : jobCardConfigured===1}"></span></div>-->
              <div>{{ 'bikeshop.quicklaunch.cyclistsConfigured' | translate }}<span class="fa right"
                  [ngClass]="{'fail fa-exclamation-triangle' : cyclistsConfigured===0, 'configured hubtiger-check' : cyclistsConfigured===1}"></span>
              </div>
              <div>{{ 'bikeshop.quicklaunch.techniciansConfigured' | translate }}<span class="fa right"
                  [ngClass]="{'fail fa-exclamation-triangle' : techniciansConfigured===0, 'configured hubtiger-check' : techniciansConfigured===1}"></span>
              </div>
              <div>{{ 'bikeshop.quicklaunch.messageTemplatesConfigured' | translate }}<span class="fa right"
                  [ngClass]="{'fail fa-exclamation-triangle' : messageTemplatesConfigured===0, 'configured hubtiger-check' : messageTemplatesConfigured===1}"></span>
              </div>
              <div>{{ 'bikeshop.quicklaunch.serviceTypesConfigured' | translate }}<span class="fa right"
                  [ngClass]="{'fail fa-exclamation-triangle' : serviceTypesConfigured===0, 'configured hubtiger-check' : serviceTypesConfigured===1}"></span>
              </div>
              <!--<div>{{ 'bikeshop.quicklaunch.checklistConfigConfigured' | translate }}<span class="fa right"
                  [ngClass]="{'fail fa-exclamation-triangle' : checklistConfigConfigured===0, 'configured hubtiger-check' : checklistConfigConfigured===1}"></span>
              </div>-->
            </div>
          </div>
        </p-card>
      </div>
      <div class="col-xl-4 col-lg-6 margin-bottom-32">
        <p-card>
          <div style="position: relative;">
            <div class="sub-header">
              <div>{{ 'bikeshop.quicklaunch.servicetypes' | translate }}</div>
              <div class="action">
                <button pButton class="borderless" label="{{'bikeshop.quicklaunch.goto_service_types' | translate}}"
                  (click)="goToServiceTypes()"></button>
              </div>
            </div>
            <div class="card-description">{{ 'onboarding.messages.service_types_info' | translate }}</div>
            <div class="content-container">
              <div class="card-description text-alert" *ngIf="!busyServiceTypes && serviceTypes.length===0">
                {{ 'bikeshop.quicklaunch.no_servicetypes' | translate }}</div>
              <div *ngIf="busyServiceTypes">
                <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
                  animationDuration=".5s">
                </p-progressSpinner>
              </div>
              <div *ngFor="let serviceType of serviceTypes">
                <div class="configuration">
                  <div class="message-template-name">
                    <div style="margin-right: auto;">{{serviceType.ServiceTypeDescription}}</div>
                    <span class="fa"
                      [ngClass]="{'fail fa-times-circle' : !serviceType.IsActive, 'configured hubtiger-check' : serviceType.IsActive}"></span>
                    <span class="fa fa-globe"
                      [ngClass]="{'configured' : serviceType.IsActive && serviceType.Show}"></span>
                    <span class="fa fa-wrench"
                      [ngClass]="{'configured' : serviceType.IsActive && serviceType.TechnicianLinked}"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-2" *ngIf="serviceTypes.length < 8"></div>
            <div class="legend">
              <div><span class="fa hubtiger-check"></span>{{ 'bikeshop.quicklaunch.servicetype_active' | translate }}</div>
              <div><span class="fa fa-times-circle"></span>{{ 'bikeshop.quicklaunch.servicetype_disabled' | translate }}
              </div>
              <div><span class="fa fa-globe"></span>{{ 'bikeshop.quicklaunch.servicetype_show_online' | translate }}
              </div>
              <div><span
                  class="fa fa-wrench"></span>{{ 'bikeshop.quicklaunch.servicetype_technician_linked' | translate }}
              </div>
            </div>
          </div>
        </p-card>
      </div>
      <div class="col-xl-4 col-lg-6 margin-bottom-32">
        <p-card>
          <div style="position:relative">
            <div class="sub-header">
              <div>{{ 'bikeshop.quicklaunch.messagetemplates' | translate }}</div>
              <div class="action">
                <button pButton class="borderless" label="{{'bikeshop.quicklaunch.goto_message_templates' | translate}}"
                  (click)="goToMessageTemplates()"></button>
              </div>
            </div>
            <div class="card-description">{{ 'bikeshop.quicklaunch.messagetemplates_description' | translate }}</div>
            <div class="content-container">
              <div *ngIf="busyMessages">
                <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
                  animationDuration=".5s">
                </p-progressSpinner>
              </div>
              <div *ngFor="let messageTemplate of messageTemplates">
                <div class="configuration">
                  <div class="message-template-name">
                    <div style="margin-right: auto;">{{messageTemplate.value}}</div>
                    <span class="fa fa-envelope"
                      [ngClass]="{'configured' : messageTemplate.IsActive && messageTemplate.Template.length>0}"></span>
                    <span class="fa fa-commenting"
                      [ngClass]="{'configured' : messageTemplate.ShortMessageActive}"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="legend">
              <div><span class="fa fa-envelope"></span>{{ 'bikeshop.quicklaunch.message_email' | translate }}</div>
              <div><span class="fa fa-commenting"></span>{{ 'bikeshop.quicklaunch.message_notifications' | translate }}
              </div>
            </div>
          </div>
        </p-card>
      </div>
    </div>


    <div class="row">
      <div id="no-fixed-height" class="col-xl-12 col-lg-12 margin-bottom-32">
        <p-card>
          <div>
            <div class="sub-header">
              <div>{{ 'bikeshop.quicklaunch.technicians' | translate }}</div>
              <div class="action">
                <button pButton class="borderless" label="{{'bikeshop.quicklaunch.goto_user_admin' | translate}}"
                  (click)="goToUsers()"></button>
              </div>
            </div>
            <div class="card-description">{{ 'bikeshop.quicklaunch.technicians_description' | translate }}</div>
            <div class="row technician-header">
              <div class="col-md-2">{{'bikeshop.quicklaunch.technician' | translate}}</div>
              <div class="col-md-1">{{'bikeshop.quicklaunch.active' | translate}}</div>
              <div class="col-md-9 row">
                <div class="col-md">{{'bikeshop.quicklaunch.monday' | translate}}</div>
                <div class="col-md">{{'bikeshop.quicklaunch.tuesday' | translate}}</div>
                <div class="col-md">{{'bikeshop.quicklaunch.wednesday' | translate}}</div>
                <div class="col-md">{{'bikeshop.quicklaunch.thursday' | translate}}</div>
                <div class="col-md">{{'bikeshop.quicklaunch.friday' | translate}}</div>
                <div class="col-md">{{'bikeshop.quicklaunch.saturday' | translate}}</div>
                <div class="col-md">{{'bikeshop.quicklaunch.sunday' | translate}}</div>
              </div>
            </div>
            <div class="card-description text-alert" *ngIf="!techniciansBusy && technicians.length===0">
              {{ 'bikeshop.quicklaunch.no_technicians' | translate }}</div>
            <div *ngFor="let technician of technicians" class="technician-data">
              <div class="row">
                <div class="col-md-2">{{technician.Firstname}} {{technician.Surname}}</div>
                <div class="col-md-1"><span class="fa"
                    [ngClass]="{'fail fa-times-circle': !technician.IsActive, 'hubtiger-check': technician.IsActive}"></span>
                </div>
                <div class="col-md-9 row">
                  <div class="col-md">{{technician.MondayStart}}-{{technician.MondayEnd}}</div>
                  <div class="col-md">{{technician.TuesdayStart}}-{{technician.TuesdayEnd}}</div>
                  <div class="col-md">{{technician.WednesdayStart}}-{{technician.WednesdayEnd}}</div>
                  <div class="col-md">{{technician.ThursdayStart}}-{{technician.ThursdayEnd}}</div>
                  <div class="col-md">{{technician.FridayStart}}-{{technician.FridayEnd}}</div>
                  <div class="col-md">{{technician.SaturdayStart}}-{{technician.SaturdayEnd}}</div>
                  <div class="col-md">{{technician.SundayStart}}-{{technician.SundayEnd}}</div>
                </div>
              </div>
            </div>
          </div>
        </p-card>
      </div>
    </div>


  </div>
</div>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>